import { useEffect, useState } from "react";

import { CqWord } from "@/utils/word";

interface UseDocumentSelectionReturn {
  contextText: string;
  selectedText: string;
}

const CONTEXT_TEXT = {
  FULL_DOCUMENT: "Using full document as context",
  SELECTION: "Using selection as context",
} as const;

export const useDocumentSelection = (): UseDocumentSelectionReturn => {
  const [selectedText, setSelectedText] = useState("");
  const [contextText, setContextText] = useState<string>(
    CONTEXT_TEXT.FULL_DOCUMENT
  );

  useEffect(() => {
    const handleSelectionChange = (text: string) => {
      setSelectedText(text);
      setContextText(
        text.trim().length > 0
          ? CONTEXT_TEXT.SELECTION
          : CONTEXT_TEXT.FULL_DOCUMENT
      );
    };

    CqWord.documentSelectionChanged(handleSelectionChange);

    return () => {
      CqWord.stopDocumentSelectionChanged();
    };
  }, []);

  return { contextText, selectedText };
};
